import { render, staticRenderFns } from "./Paragraphe.vue?vue&type=template&id=46eb63b7&scoped=true"
import script from "./Paragraphe.vue?vue&type=script&lang=js"
export * from "./Paragraphe.vue?vue&type=script&lang=js"
import style0 from "./Paragraphe.vue?vue&type=style&index=0&id=46eb63b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eb63b7",
  null
  
)

export default component.exports